import { Auth } from "../auth.js"

//お知らせ操作
export class NoticeController {
    constructor(apiRootPath){
        apiRootPath ??= window.Setting.api
        this.url = apiRootPath + "notice" 
    }
    /**
     * GET
     * notice/all
     */
    async all(){
        let res = await Auth.ajax({
            url: `${this.url}/all`,
        })
        if(res.ok){
            let obj = JSON.parse(res.body)
            obj.forEach(function(x){
                x.noticeTime = new Date(x.noticeTime * 1000)
            })
            res.data = obj
        }
        return res
    }
    /**
     * GET
     * notice/showall
     */
     async showAll(){
        let res = await Auth.ajax({
            url: `${this.url}/showall`,
        })
        if(res.ok){
            let obj = JSON.parse(res.body)
            obj.forEach(function(x){
                x.noticeTime = new Date(x.noticeTime * 1000)
            })
            res.data = obj
        }
        return res
    }
    /**
     * POST
     * notice/add
     * @param {number} state
     * @param {number} target
     * @param {long} noticeTime
     * @param {string} subject
     * @param {string} message
     */
    async add(state, target, noticeTime, subject, message){
        let res = await Auth.ajax({
            url: `${this.url}/add`,
            method: "POST",
            body: {
                id : 0,
                state  : state,
                target : target,
                noticeTime : noticeTime,
                subject : subject,
                message : message,
            }
        })
        return res
    }

    /**
     * POST
     * notice/update
     * @param {number} id
     * @param {number} state
     * @param {number} target
     * @param {long} noticeTime
     * @param {string} subject
     * @param {string} message
     */
    async update(id, state, target, noticeTime, subject, message) {
        let res = await Auth.ajax({
            url: `${this.url}/add`,
            method: "POST",
            body: {
                id : id,
                state: state,
                target: target,
                noticeTime: noticeTime,
                subject: subject,
                message: message,
            }
        })
        return res
    }

    /**
     * POST
     * notice/delete
     * @param {number} id
     */
    async delete(id){
        let res = await Auth.ajax({
            url: `${this.url}/delete`,
            method: "POST",
            body: id,
        })
        return res
    }
}